export default class Utils {
  static docEvent(obj: string) {
    let result = null;
    switch (obj) {
      case 'nsFTS::FILE_EVENT_CREATE':
        result = '생성';
        break;
      case 'nsFTS::FILE_EVENT_COPY':
        result = '복사';
        break;
      case 'nsFTS::FILE_EVENT_DELETE':
        result = '삭제';
        break;
      case 'nsFTS::FILE_EVENT_RENAME':
        result = '이름변경';
        break;
      case 'nsFTS::FILE_EVENT_WRITE':
        result = '쓰기';
        break;
      case 'create':
        result = '생성';
        break;
      case 'delete':
        result = '삭제';
        break;
      case 'rename':
        result = '이름변경';
        break;
      case 'open':
        result = '파일열기';
        break;
      case 'close':
        result = '닫기';
        break;
      case 'read':
        result = '읽기';
        break;
      case 'write':
        result = '쓰기';
        break;
      case 'copy':
        result = '복사';
        break;
    }
    return result;
  }

  /**
   * 숫자를 전달받아 1자리 숫자인 경우 앞에 0을 추가하여 리턴
   * @param obj 1~9 숫자
   */
  static setAddZero(obj: number): any {
    return obj > 9 ? obj : `0${obj}`;
  }

  /**
   * { year: number, month: number, day: number }를 전달받아
   * yyyy-MM-dd 문자열로 리턴
   * @param obj { year: number, month: number, day: number }
   */
  static setYYYMMDD(obj: Date): string {
    return `${obj.getFullYear()}-${this.setAddZero(
      obj.getMonth() + 1,
    )}-${Utils.setAddZero(obj.getDate())}`;
  }

  /**
   * DB에서 조회된 DateTime을 입력받아 00:00 문자열로 리턴
   * @param obj
   */
  static dateToTime(obj: string): any {
    const date = new Date(obj);
    return `${this.setAddZero(date.getHours())}:${this.setAddZero(
      date.getMinutes(),
    )}`;
  }

  static fileParser(data: any) {
    const fileName = data.split('\\');
    return fileName[fileName.length - 1];
  }

  static fileNameParser(data: any) {
    if (typeof data !== 'object') {
      data.parentFileIds = JSON.parse(data.parentFileIds);
    }
    const fileName = data.fileName.split('\\');
    data.fileName = fileName[fileName.length - 1];
    return data;
  }

  static datasParser(datas: any): any {
    datas.content.forEach((d: any) => {
      const fileName = d.fileName.split('\\');
      d.fileName = fileName[fileName.length - 1];
    });
    return datas;
  }

  /**
   * 추가일을 포함한 날짜 계산
   * @param obj 날짜
   * @param num 추가일
   */
  static setAddData(obj: Date, num: number): Date {
    return new Date(obj.setDate(obj.getDate() + num));
  }

  /**
   * 날짜를 MM/DD(Day) 타입으로 변경
   * @param obj 날짜
   */
  static setData(obj: Date) {
    return `${this.setAddZero(obj.getMonth() + 1)}/${this.setAddZero(
      obj.getDate(),
    )}(${this.weekDay(obj.getDay(), 'KO')})`;
    // return `${this.setAddZero(obj.getMonth() + 1)}/${this.setAddZero(obj.getDate())}`;
  }

  /**
   * 날짜를 YYYYMMDD 타입으로 변경
   * @param obj 날짜
   */
  static setData2(obj: Date) {
    return `${obj.getFullYear()}${this.setAddZero(
      obj.getMonth() + 1,
    )}${this.setAddZero(obj.getDate())}`;
  }

  /**
   * 요일 값을 전달받아 처리
   * @param value
   */
  static weekDay(value: number, language: any) {
    if (language === 'KO') {
      switch (value) {
        case 0:
          return '일';
        case 1:
          return '월';
        case 2:
          return '화';
        case 3:
          return '수';
        case 4:
          return '목';
        case 5:
          return '금';
        case 6:
          return '토';
      }
    } else if (language === 'EN') {
      switch (value) {
        case 0:
          return 'SUN';
        case 1:
          return 'MON';
        case 2:
          return 'TUE';
        case 3:
          return 'WED';
        case 4:
          return 'THU';
        case 5:
          return 'FRI';
        case 6:
          return 'SAT';
      }
    }
  }

  /**
   * 0시 0분 0초로 초기화
   * @param date
   */
  static setZeroBase(date: Date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }

  /**
   * 배열을 전달받아 정렬
   * @param obj []
   * @param name no, name, icon...
   * @param type string, number
   * @param orderBy desc, asc
   */
  static setSort(obj: any, name: string, type: string, orderBy: string) {
    return obj.sort((a, b) => {
      if (type === 'string') {
        if (orderBy === 'desc') {
          return a[name] < b[name] ? -1 : a[name] > b[name] ? 1 : 0;
        }
        if (orderBy === 'asc') {
          return a[name] > b[name] ? -1 : a[name] < b[name] ? 1 : 0;
        }
      }

      if (type === 'number') {
        if (orderBy === 'desc') {
          return a[name] - b[name];
        }
        if (orderBy === 'asc') {
          return b[name] - a[name];
        }
      }
    });
  }

  /**
   * 차단알림 타입 구분
   * @param type 차단 유형
   */
  static commonBlockType(type): any {
    switch (type) {
      case 'NOTAUTHROIZED_ACCESS':
        return '타그룹 문서 접근 시도';
      case 'INTERNAL_NOT_INSTALLED_ACCESS':
          return '그룹내 미설치 문서 접근 시도';
      case 'NOTAUTHROIZED_IP':
        return '반출PC 비인가 접속';
      case 'NOTAUTHROIZED_INSTALL':
        return '비인가 열람';
      case 'NOTAUTHROIZED_INSTALL':
        return '비인가 열람';
      case 'EXTERNAL_ACCESS':
        return '외부 열람';
      case 'LOST_MEDIA':
        return '매체 분실';
      default:
        return '(Unkown Type)';
    }
  }

  /**
   * 차단알림 결과 구분
   * @param type 결과 유형
   */
  static commonBlockResultType(type): any {
    switch (type) {
      case 'WAITING':
        return '대기';
      case 'SAFETY':
        return '안전';
      case 'DANGER':
        return '위험';
      case 'HOLD':
        return '보류';
    }
  }

  /**
   * 신청이력 처리 결과
   */
  static approvalState(type): any {
    switch (type) {
      case 'WAIT':
        return '미확인';
      case 'APPROVED':
        return '승인';
      case 'REJECT':
        return '차단';
    }
  }

  /**
   * 신청이력 신청유형
   */
  static applyType(type): any {
    switch (type) {
      case 'CLIENT':
        return '에이전트 신청';
      case 'IP':
        return 'IP 신청';
      case 'COMPANY':
        return '그룹 신청';
    }
  }

  static fileArraySplit(stringFileArray: any): any {
    stringFileArray = stringFileArray.replaceAll('[').replaceAll(']');
    return stringFileArray.replaceAll('[').replaceAll(']');
  }

  static getSwTypeAsString(swType: number) {
    switch (swType) {
      case 0:
        return '미지정';
      case 3111:
        return '운영체제';
      case 3112:
        return '통신';
      case 3113:
        return '유틸리티';
      case 3114:
        return '시스템관리';
      case 3115:
        return '정보보호';
      case 3116:
        return '미들웨어';
      case 3119:
        return '시스템기타';
      case 3121:
        return '개발언어';
      case 3122:
        return '프로그램및컨텐츠개발도구';
      case 3123:
        return '프로젝트관리';
      case 3124:
        return 'DBMS';
      case 3129:
        return '개발도구기타';
      case 3131:
        return '일반사무용';
      case 3132:
        return '기업관리용';
      case 3133:
        return '과학/수학';
      case 3134:
        return '산업';
      case 3139:
        return '응용프로그램기타';
      case 4000:
        return 'FONT';
      default:
        return '미지정';
    }
  }
}
